import React, { useEffect, useState } from "react";

import {  ContactInfo, ContactPhoneEmail, TitlePhoneEmail,  UserInfo,  UserInfoContact } from "../../../../components/ui/Content";

import {
    Body1PointerLink,
    ConfirmedText,
    TitleСontact
} from "../../../../components/Font";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import { ExternalAccount } from "../../../../interface/Passport/Account/frontend";
import {DeleteExternalAccount} from "../api/slice";
import { Popup } from "../../../../ui/Modal/Popup";
import { ModalActiveBtn, ModalDefaultBtn } from "../../../../components/ui/Button";
import styled from "styled-components";
// import { useTranslation } from "react-i18next";

interface IProps {
    name: string, 
    connected: boolean,
    url?: string | null,
    alias: string,
    isDeletable: boolean,
}

const ConfirmationModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px 24px;
    text-align: center;
`;

const ButtonsContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 24px;
`;

const AccountRow: React.FC<IProps> = ({name, connected, url, alias, isDeletable}) => {
    // const { t } = useTranslation();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const handleClick = (url: string) => {
        window.open(url, '_blank');
    };
    const dispatch = useAppDispatch();

    const handleDisconnect = () => {
        setShowConfirmModal(true);
    };

    const confirmDisconnect = () => {
        dispatch(DeleteExternalAccount(alias));
        setShowConfirmModal(false);
    };

    const cancelDisconnect = () => {
        setShowConfirmModal(false);
    };

    return (
        <>
            <ContactPhoneEmail>
                <ContactInfo>
                    <TitlePhoneEmail>{name === 'Сбер ID' ? <img style={{width: '76px', position: 'relative', top: '2px'}} src="icons/sber_id.jpg" alt="" /> : name}</TitlePhoneEmail>
                    {connected ? <ConfirmedText>подключена</ConfirmedText> : <ConfirmedText style={{color: 'black'}}>не подключена</ConfirmedText>}
                </ContactInfo>
                <Body1PointerLink
                    style={{marginLeft: 'auto'}}
                    className={'personalInfoChange'}
                    onClick={() => connected && isDeletable ? handleDisconnect() : handleClick(url ? url : '')}>
                    {connected ? (isDeletable ? 'Отключить' : 'Обновить') : 'Подключить'}
                </Body1PointerLink>
            </ContactPhoneEmail>

            <Popup
                opened={showConfirmModal}
                onClose={cancelDisconnect}
                title={`Отвязать ${name}`}
                style={{ width: '400px', height: 'auto', padding: '0' }}
            >
                <ConfirmationModalContent>
                    <p>Вы уверены, что хотите отвязать {name}?</p>
                    {/*<p>После отвязки вы не сможете использовать этот аккаунт для входа в систему.</p>*/}
                    
                    <ButtonsContainer>
                        <ModalDefaultBtn onClick={cancelDisconnect}>
                            Отмена
                        </ModalDefaultBtn>
                        <ModalActiveBtn onClick={confirmDisconnect}>
                            Отвязать
                        </ModalActiveBtn>
                    </ButtonsContainer>
                </ConfirmationModalContent>
            </Popup>
        </>
    )
}

export const ExternalAccounts = () => {
    const { externalAccountsData } = useAppSelector(state => state.account)
    const [linkToSberID, setLinkToSberID] = useState()

    const data = externalAccountsData?.data
    console.log(data);

    useEffect(() => {
        const SberidSDK = window.SberidSDK
        const findSber = ({sber}: ExternalAccount) => sber
        const [sberData]: ExternalAccount[] = data?.filter(findSber) || [];
        const sber = sberData ? sberData.sber : null

        if (data?.length && sber) {

            const sberOptions = {
                oidc: sber,
            }
            if(location.hostname !== 'id.rudn.ru'){
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                sberOptions.baseUrl = "https://id-psi.sber.ru"
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            new SberidSDK(sberOptions)
                .init()
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                .then((sdk) => {
                    setLinkToSberID(sdk.getLink());
            });
        }
        }, [data])
            
    if (!data?.length) {
        return null
    }

    return (
        <UserInfo cursor="default">
            <UserInfoContact>
                <TitleСontact>Связать со Сбер ID</TitleСontact>
                {data?.map(({name, alias, connected, url, sber, isDeletable}: ExternalAccount , index: number) => <AccountRow key={index} alias={alias} isDeletable={isDeletable} name={name} connected={connected} url={sber ? linkToSberID : url} />)}
            </UserInfoContact>
        </UserInfo>
    )
}
